exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".es-calendar-week[data-v-12b24a84]{display:flex;border-top:1px solid #f3f4f5;line-height:36px;padding:0 6px}.es-calendar-week__item[data-v-12b24a84]{flex:1;font-size:14px;text-align:center;font-family:PingFangSC-Regular;color:#333}.es-calendar-week__holiday[data-v-12b24a84]{color:#ff6400}", ""]);

// exports
